/**
 * Gruppkraft — flerstegsformulär för intresseanmälan (och återanvänds för
 * leverantörsformuläret, som bara har ett steg).
 *
 * Formuläret postar som standard till Shopify's inbyggda kontaktformulär
 * (action="/contact#<id>"), vilket gör att:
 *   - en notis skickas till butikens angivna e-post
 *   - Shopify Flow kan triggas av "Customer form submitted"
 * Om data-webhook-url anges på <form> skickas dessutom (icke-blockerande)
 * en JSON-payload dit, t.ex. för Klaviyo, Mailchimp eller ett eget CRM.
 * Se README.md för kopplingsinstruktioner.
 *
 * Vanilla JS, inga externa beroenden.
 */
(function () {
  "use strict";

  // Källa för kampanjspårning: första sidan i besöket, hänvisande sajt och
  // UTM-parametrar. Sparas bara i sessionStorage (försvinner när fliken stängs).
  var ATTR_KEY = "gk_lead_source";
  function captureSource() {
    try {
      if (sessionStorage.getItem(ATTR_KEY)) return;
      var params = new URLSearchParams(window.location.search);
      var src = {
        landing: window.location.pathname,
        referrer: document.referrer && document.referrer.indexOf(window.location.host) === -1 ? document.referrer : "",
      };
      ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach(function (k) {
        src[k] = params.get(k) || "";
      });
      sessionStorage.setItem(ATTR_KEY, JSON.stringify(src));
    } catch (err) {
      /* sessionStorage kan vara blockerat — formuläret fungerar ändå */
    }
  }
  function readSource() {
    try {
      return JSON.parse(sessionStorage.getItem(ATTR_KEY)) || {};
    } catch (err) {
      return {};
    }
  }
  captureSource();

  document.addEventListener("DOMContentLoaded", function () {
    document
      .querySelectorAll("[data-multistep-form]")
      .forEach(initMultistepForm);
  });

  function makeLeadRef(prefix) {
    var chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    var out = "";
    for (var i = 0; i < 6; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
    return (prefix || "POL") + "-" + out;
  }

  function initMultistepForm(root) {
    var form = root.querySelector("form");
    if (!form) return;

    var steps = Array.prototype.slice.call(
      root.querySelectorAll("[data-form-step]")
    );
    var indicators = Array.prototype.slice.call(
      root.querySelectorAll("[data-step-indicator]")
    );
    var confirmation = root.querySelector("[data-form-confirmation]");
    var statusEl = root.querySelector("[data-form-status]");
    var submitBtn = form.querySelector('[type="submit"]');
    var currentIndex = 0;

    var source = readSource();
    form.querySelectorAll("[data-utm]").forEach(function (input) {
      input.value = source[input.getAttribute("data-utm")] || "";
    });

    function isCampaignLead() {
      var chosen = form.querySelector("[data-campaign-choice]:checked");
      return !!chosen && chosen.getAttribute("data-campaign-choice") === "ja";
    }

    var tagsInput = form.querySelector("[data-lead-tags]");
    var baseTags = tagsInput ? tagsInput.value : "";
    var refInput = form.querySelector("[data-lead-ref]");
    var leadRef = makeLeadRef(form.getAttribute("data-campaign-prefix"));

    form.querySelectorAll("[data-campaign-choice]").forEach(function (radio) {
      radio.addEventListener("change", function () {
        var yes = isCampaignLead();
        if (tagsInput) tagsInput.value = yes ? baseTags + ", kampanj" : baseTags;
        if (refInput) refInput.value = yes ? leadRef : "";
        window.gkTrackEvent &&
          window.gkTrackEvent("kampanj_choice", { form: form.getAttribute("data-form-name") || form.id, choice: yes ? "ja" : "nej" });
      });
    });

    function showStep(index, opts) {
      opts = opts || {};
      steps.forEach(function (step, i) {
        step.setAttribute("data-active", String(i === index));
      });
      indicators.forEach(function (indicator, i) {
        var state = "pending";
        if (i < index) state = "done";
        if (i === index) state = "active";
        indicator.setAttribute("data-state", state);
      });
      currentIndex = index;
      if (opts.skipScroll) return;
      var heading = steps[index].querySelector("h2, h3");
      if (heading) {
        heading.setAttribute("tabindex", "-1");
        heading.focus({ preventScroll: false });
      }
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function validateStep(step) {
      var fields = step.querySelectorAll("[required]");
      var valid = true;
      fields.forEach(function (field) {
        var wrapper = field.closest(".field") || field.parentElement;
        var isValid = field.checkValidity();

        if (field.type === "radio" || field.type === "checkbox") {
          var groupName = field.name;
          var group = step.querySelectorAll(
            'input[name="' + cssEscape(groupName) + '"]'
          );
          isValid = Array.prototype.some.call(group, function (g) {
            return g.checked;
          });
          wrapper =
            field.closest("[data-field-group]") ||
            field.closest(".field") ||
            field.parentElement;
        }

        if (!isValid) {
          valid = false;
          if (wrapper) wrapper.setAttribute("data-invalid", "true");
        } else if (wrapper) {
          wrapper.removeAttribute("data-invalid");
        }
      });
      return valid;
    }

    function cssEscape(value) {
      return String(value).replace(/([\s#.;,+*~':"!^$[\]()=>|/])/g, "\\$1");
    }

    // Villkorliga fält, t.ex. <div data-show-if="solceller:ja">…</div>
    // visas bara när ett fält med name="solceller" har värdet "ja".
    function setupConditionals() {
      var conditionals = root.querySelectorAll("[data-show-if]");
      if (!conditionals.length) return;

      function evaluate() {
        conditionals.forEach(function (el) {
          var rule = el.getAttribute("data-show-if").split(":");
          var fieldName = rule[0];
          var expected = rule[1];
          var checked = form.querySelector(
            '[name="' + cssEscape(fieldName) + '"]:checked'
          );
          var value = checked
            ? checked.value
            : (function () {
                var field = form.querySelector(
                  '[name="' + cssEscape(fieldName) + '"]'
                );
                return field ? field.value : "";
              })();
          el.hidden = value !== expected;
        });
      }

      form.addEventListener("change", evaluate);
      evaluate();
    }

    setupConditionals();

    root.querySelectorAll("[data-step-next]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = steps[currentIndex];
        if (!validateStep(step)) {
          var firstInvalid = step.querySelector('[data-invalid="true"]');
          if (firstInvalid) {
            var input = firstInvalid.querySelector("input, select, textarea");
            if (input) input.focus();
          }
          if (statusEl) {
            statusEl.textContent =
              "Kontrollera fälten som är markerade ovan innan du går vidare.";
          }
          return;
        }
        if (statusEl) statusEl.textContent = "";
        window.gkTrackEvent && window.gkTrackEvent("form_step_completed", {
          form: form.getAttribute("data-form-name") || form.id,
          step: currentIndex + 1,
        });
        if (currentIndex < steps.length - 1) {
          showStep(currentIndex + 1);
        }
      });
    });

    root.querySelectorAll("[data-step-prev]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (currentIndex > 0) showStep(currentIndex - 1);
      });
    });

    // Spåra att formuläret påbörjats (första interaktionen med ett fält)
    var startedTracked = false;
    form.addEventListener(
      "focusin",
      function () {
        if (startedTracked) return;
        startedTracked = true;
        window.gkTrackEvent &&
          window.gkTrackEvent("form_started", {
            form: form.getAttribute("data-form-name") || form.id,
          });
      },
      true
    );

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      var lastStep = steps[steps.length - 1];
      if (!validateStep(lastStep)) {
        if (statusEl) {
          statusEl.textContent =
            "Kontrollera fälten som är markerade ovan innan du skickar in.";
        }
        return;
      }

      // Honeypot: om fältet är ifyllt är det sannolikt en bot.
      // Vi låtsas att allt gick bra men skickar aldrig in data.
      var honeypot = form.querySelector('[data-honeypot]');
      if (honeypot && honeypot.value) {
        showConfirmation();
        return;
      }

      // CAPTCHA: om ett reCAPTCHA-element finns måste det vara verifierat
      // innan formuläret får skickas in.
      var recaptchaEl = root.querySelector('[data-recaptcha]');
      if (recaptchaEl) {
        var recaptchaWrapper = recaptchaEl.closest(".field") || recaptchaEl;
        var recaptchaResponse = window.grecaptcha
          ? window.grecaptcha.getResponse()
          : "";
        if (!recaptchaResponse) {
          recaptchaWrapper.setAttribute("data-invalid", "true");
          if (statusEl) {
            statusEl.textContent =
              "Bekräfta att du inte är en robot innan du skickar.";
          }
          recaptchaWrapper.scrollIntoView({ behavior: "smooth", block: "center" });
          return;
        }
        recaptchaWrapper.removeAttribute("data-invalid");
      }

      if (submitBtn) {
        submitBtn.setAttribute("aria-disabled", "true");
        submitBtn.disabled = true;
        submitBtn.textContent =
          submitBtn.getAttribute("data-loading-text") || "Skickar …";
      }

      var formData = new FormData(form);

      fetch(form.getAttribute("action"), {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      })
        .then(function () {
          var webhookUrl = form.getAttribute("data-webhook-url");
          if (webhookUrl) {
            sendWebhook(webhookUrl, formData);
          }
          var campaign = isCampaignLead();
          window.gkTrackEvent &&
            window.gkTrackEvent("form_submitted", {
              form: form.getAttribute("data-form-name") || form.id,
              kampanj: campaign ? "ja" : "nej",
            });
          if (campaign) {
            window.gkTrackEvent &&
              window.gkTrackEvent("kampanj_lead", {
                form: form.getAttribute("data-form-name") || form.id,
                lead_ref: leadRef,
                source_page: window.location.pathname,
                utm_source: source.utm_source || "",
                utm_campaign: source.utm_campaign || "",
              });
            var refBox = root.querySelector("[data-lead-ref-box]");
            var refCode = root.querySelector("[data-lead-ref-code]");
            if (refBox && refCode) {
              refCode.textContent = leadRef;
              refBox.hidden = false;
            }
          }
          showConfirmation();
        })
        .catch(function () {
          if (statusEl) {
            statusEl.textContent =
              "Något gick fel när formuläret skulle skickas. Kontrollera din internetanslutning och försök igen, eller kontakta oss direkt.";
          }
          if (submitBtn) {
            submitBtn.removeAttribute("aria-disabled");
            submitBtn.disabled = false;
            submitBtn.textContent =
              submitBtn.getAttribute("data-default-text") || "Skicka";
          }
        });
    });

    function sendWebhook(url, formData) {
      var payload = {};
      formData.forEach(function (value, key) {
        if (payload[key] !== undefined) {
          payload[key] = [].concat(payload[key], value);
        } else {
          payload[key] = value;
        }
      });
      fetch(url, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }).catch(function () {
        /* Webhook-fel ska inte blockera bekräftelsen till användaren */
      });
    }

    function showConfirmation() {
      root.setAttribute("data-submitted", "true");
      if (confirmation) {
        confirmation.setAttribute("data-active", "true");
        confirmation.setAttribute("tabindex", "-1");
        confirmation.focus();
        confirmation.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    if (steps.length) showStep(0, { skipScroll: true });
  }
})();
